var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ac-material-dropdown',{attrs:{"button_options":_vm.dropdown.button_options,"show_icon":true,"url":"https://api.myjson.com/bins/lvaxd"},on:{"item_click":_vm.event_test}})}
var staticRenderFns = []

export { render, staticRenderFns }